import { PersonRequest } from "@plinknz/tah-website-elements";
import { bankConfig } from "./config-generics/bank-details";
import { personalDetailsConfig } from "./config-generics/personal-details";
import { signatureConfig } from "./config-generics/signature";
import { PageConfig } from "../../components/content-blocks/forms/customer-form-types";
import { UserData } from "../reducers/user";
import { overviewConfig } from "./config-generics/overview";

export const createSurveyConfig = (member: PersonRequest, user?: UserData) => {
    const personalConfig = personalDetailsConfig({
        member,
        children: user.onSameEmail,
    });

    const overviewDetailsConfig = overviewConfig({
        heading: "Tahua Hākinakina | Sports Grant",
        content: [
            {
                heading: "Overview",
                lines: [
                    `Supports participation in sport at regional, national, or international
          levels. It is for registered Ngāti Kuia whānau who have been selected to
          represent their rohe, club, or country in competitive sport.`,
                ],
            },
            {
                heading: "Eligibility",
                lines: [
                    "To apply for this grant, you must:",
                    [
                        "Be a registered member of Ngāti Kuia",
                        "Provide proof of bank account (deposit form or electronic statement).",
                        "Provide an invitation to participate in sport at the regional, national, or international level.",
                        "Complete this form",
                    ],
                ],
            },
            {
                heading: "Key Dates & Deadlines",
                lines: [
                    [
                        "Deadline: six weeks before the event.",
                        "Payment: before the event.",
                    ],
                ],
            },
            {
                heading: "Funding Available",
                lines: [
                    "Varies depending on the level of representation:",
                    [
                        "Regional: up to $200",
                        "Nationals: up to $350",
                        "International: up to $750",
                    ],
                    "Applicants are eligible for one grant every 12 months.",
                ],
            },
            {
                heading: "Documents You'll Need",
                lines: [
                    [
                        "Bank account details (deposit form or electronic statement).",
                        "Proof of invitation to participate in sport at the regional, national, or international level.",
                    ],
                ],
            },
        ],
    });

    const otherConfig: PageConfig[] = [
        {
            name: "benefit",
            title: "Relevance to Ngāti Kuia - Hāngai ki Ngāti Kuia",
            questions: [
                {
                    name: "purpose",
                    title: "Purpose of Grant",
                    placeHolder: "Kaupapa",
                    type: "comment",
                    isRequired: true,
                },
                {
                    name: "benefit",
                    title: "How will this be of benefit to Ngāti Kuia?",
                    placeHolder: "Ngā hua",
                    type: "comment",
                    isRequired: true,
                },
            ],
        },
        {
            name: "attachments",
            title: "Attachments - Tuhinga",
            questions: [
                {
                    type: "file",
                    name: "costs",
                    title: `
                        Please upload quotes or a breakdown of costs. If you are
                        unable to upload, please email directly to
                        grant@ngatikuia.iwi.nz.
                    `,
                    storeDataAsText: false,
                    allowMultiple: true,
                    maxSize: 10485760,
                    waitForUpload: true,
                    startWithNewLine: true,
                },
                {
                    type: "file",
                    name: "involvementProof",
                    title: `
                        Please upload your team selection letter or other proof
                        of your involvement in the sport. If you are
                        unable to upload, please email directly to
                        grant@ngatikuia.iwi.nz.
                    `,
                    storeDataAsText: false,
                    allowMultiple: false,
                    maxSize: 10485760,
                    waitForUpload: true,
                    startWithNewLine: true,
                },
            ],
        },
    ];

    const pages: PageConfig[] = [
        ...overviewDetailsConfig,
        ...personalConfig,
        ...bankConfig,
        ...otherConfig,
        ...signatureConfig,
    ];

    return { pages };
};
